import RespondentDashboardService, {getOrganisationInternationalSourcesofFunds,getOrganisationSurveyStatus} 
 from './RespondentDashboardService';

export default {RespondentDashboardService, getOrganisationSurveyStatus, getOrganisationInternationalSourcesofFunds}